import { translate } from '../../../../Greativ/helper/translation'

export default function __(key, replace) {
  return translate(window.ticket.translations, key, replace)
}
